// extracted by mini-css-extract-plugin
module.exports = {"container":"RemoveExpirationActionButtons_container__jCp17","buttons":"RemoveExpirationActionButtons_buttons__1rPSF"};